export default __webpack_public_path__ + "static/media/ScenicAndCulturalTrips6.987b4674.png";